import React, { useEffect, useState } from "react";
import { Users, ThumbsUp, MessageSquare, Database, ShieldCheck, Crown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BRANDS = { kajaria: "Kajaria", vans: "Vans (VF Corp)", igl: "IGL" };

export default function Admin() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetch(`${API}/admin/overview`, { credentials: "include" })
      .then((r) => { if (!r.ok) throw new Error("forbidden"); return r.json(); })
      .then(setData).catch(() => setErr(true));
  }, []);

  if (err) return <div className="empty-state">Admin access required.</div>;
  if (!data) return <div className="loading-page">Loading admin overview…</div>;

  return (
    <div className="admin-page">
      <div className="admin-head"><Crown size={17} /> Admin Console <span>— usage & feedback across all design-partner POCs</span></div>

      <div className="metrics-row">
        <div className="metric" style={{ borderTopColor: "#4f46e5" }}>
          <div className="metric-icon" style={{ background: "#eef2ff", color: "#4f46e5" }}><Users size={18} /></div>
          <div className="metric-value">{data.totals.users}</div><div className="metric-label">Users signed in</div>
        </div>
        {Object.entries(data.feedback).map(([k, f]) => (
          <div key={k} className="metric" style={{ borderTopColor: "#059669" }}>
            <div className="metric-icon" style={{ background: "#ecfdf5", color: "#059669" }}><ThumbsUp size={18} /></div>
            <div className="metric-value">{f.total}</div>
            <div className="metric-label">{BRANDS[k]} feedback</div>
            <div className="metric-sub">{f.useful} useful · {f.correct} correct</div>
          </div>
        ))}
      </div>

      <div className="dash-cols">
        <section className="panel">
          <div className="panel-h"><span><Users size={15} /> Users</span></div>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Last login</th></tr></thead>
              <tbody>
                {data.users.map((u) => (
                  <tr key={u.user_id}>
                    <td>{u.name || "—"}</td>
                    <td>{u.email}</td>
                    <td>{u.role === "admin"
                      ? <span className="role-badge admin"><Crown size={11} /> admin</span>
                      : <span className="role-badge">member</span>}</td>
                    <td className="td-muted">{(u.last_login || "").slice(0, 16).replace("T", " ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="panel">
          <div className="panel-h"><span><Database size={15} /> Data & connectors</span></div>
          <div className="admin-data">
            {Object.entries(data.data_status).map(([k, s]) => (
              <div key={k} className="admin-data-row">
                <div className="adr-name">{BRANDS[k]}</div>
                <div className="adr-stats">
                  <span><Database size={12} /> {s.connectors} connectors</span>
                  <span><MessageSquare size={12} /> {s.situations ?? s.decisions} {s.decisions != null ? "decisions" : "situations"}</span>
                </div>
              </div>
            ))}
            <div className="admin-guard"><ShieldCheck size={13} /> Access restricted to @dotiq.ai · sandbox data is synthetic</div>
          </div>
        </section>
      </div>
    </div>
  );
}
